import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_does_the_fac_prov_comm_and_training_to_supplierssubcontract'

export const dataPointDefinition = {
  retracedId: 'how_does_the_fac_prov_comm_and_training_to_supplierssubcontract',
  name: 'How does the facility provide communication and training to suppliers/subcontractors?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'VERBAL_COMMUNICATION',
      text: 'Verbal communication',
      externalIds: [
        {
          id: 'ms-5--12-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WRITTEN_COMMUNICATION_I_E_SUPPLY_CONTRACTS_MIGHT_INCLUDE_REFERE',
      text: 'Written communication (i.e. supply contracts might include reference to social and labor practices)',
      externalIds: [
        {
          id: 'ms-5--12-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MULTI_MEDIA_COMMUNICATION_I_E_VIDEO_ONLINE_LEARNING_ETC_',
      text: 'Multi-media communication (i.e. video, online learning, etc.)',
      externalIds: [
        {
          id: 'ms-5--12-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAINING_NEW_SUBCONTRACTORS_SUPPLIERS_RECEIVE_ONBOARDING_TRAINI',
      text: 'Training - new subcontractors/suppliers receive onboarding trainings in-person (i.e. classroom trainings etc.)',
      externalIds: [
        {
          id: 'ms-5--12-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAINING_EXISTING_SUBCONTRACTORS_SUPPLIERS_RECEIVE_ON_GOING_TRA',
      text: 'Training - existing subcontractors/suppliers receive on-going trainings in-person (i.e. classroom trainings etc.)',
      externalIds: [
        {
          id: 'ms-5--12-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-5--12-6x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-5--12-6f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'VERBAL_COMMUNICATION',
                'WRITTEN_COMMUNICATION_I_E_SUPPLY_CONTRACTS_MIGHT_INCLUDE_REFERE',
                'MULTI_MEDIA_COMMUNICATION_I_E_VIDEO_ONLINE_LEARNING_ETC_',
                'TRAINING_NEW_SUBCONTRACTORS_SUPPLIERS_RECEIVE_ONBOARDING_TRAINI',
                'TRAINING_EXISTING_SUBCONTRACTORS_SUPPLIERS_RECEIVE_ON_GOING_TRA',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-25',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 22870,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
